export class MedicalCondition {
    Id: number;
    DateConditionStarted: Date;
    DateConditionEnded: Date;
    MedicalConditionCodeId: number;
    DateHomeTeachingStarte: Date;
    DateHomeTeachingEnded: Date;
    GenerateAlert: boolean;
    NonNurseViewable: boolean;
    Referral: boolean;
    ReferralReturnedToSchool: boolean;
    DateReferralReturned: Date;
    UnderDoctorsCare: boolean;
    Comment: string;
    MedicalConditionCode: string;
    MedicalConditionDescription: string;
}

export class MedicalConditionCodes {
    Id: number;
    ShowAlert: boolean;
    ViewableByNonNurse: boolean;
    Code: string;
    CodeDescription: string;
    Sequence: number;
}